"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var push_notification_service_1 = require("../../shared/services/api/push-notification.service");
var idm_session_data_provider_api_js_1 = require("@synisys/idm-session-data-provider-api-js");
var operators_1 = require("rxjs/operators");
var Subject_1 = require("rxjs/Subject");
var NotificationBoxComponent = /** @class */ (function () {
    function NotificationBoxComponent(_eventBase, _notificationService, _cd, _ngZone) {
        this._eventBase = _eventBase;
        this._notificationService = _notificationService;
        this._cd = _cd;
        this._ngZone = _ngZone;
        this.notifications = [];
        this.requestPushNotificationPermission = false;
        this._destroy$ = new Subject_1.Subject();
    }
    NotificationBoxComponent.prototype.ngOnInit = function () {
        var _this = this;
        this._initEventBaseListener();
        this._notificationService.requestPermission();
        this._checkNotificationsInterval = this._ngZone.runOutsideAngular(function () { return window.setInterval(function () { return _this._checkNotifications(); }, 60000); });
    };
    NotificationBoxComponent.prototype.ngOnDestroy = function () {
        window.clearInterval(this._checkNotificationsInterval);
        this._destroy$.next(true);
        this._destroy$.complete();
    };
    NotificationBoxComponent.prototype.snoozeNotification = function (notification) {
        notification.isHidden = true;
        this._eventBase.publish('snooze-notification', { 'id': notification.id });
    };
    NotificationBoxComponent.prototype.closeNotification = function (notification) {
        notification.isHidden = true;
        this._eventBase.publish('close-notification', { 'id': notification.id });
    };
    NotificationBoxComponent.prototype._initEventBaseListener = function () {
        var _this = this;
        this._eventBase.listen('show-notification')
            .pipe(operators_1.takeUntil(this._destroy$))
            .subscribe(function (event) {
            // mark all existing notifications as not new
            var oldNotifications = _this.notifications.map(function (notification) {
                notification.isNew = false;
                return notification;
            });
            // add new incoming notifications and mark them as new
            var newNotifications = event.data.map(function (notification) {
                return __assign({}, notification, { isNew: true, lifetime: 1, isHidden: false });
            }).reverse();
            if (document.hidden) {
                _this._notificationService.generateNotification(newNotifications);
            }
            _this.notifications = newNotifications.concat(oldNotifications);
            _this._cd.markForCheck();
        });
    };
    NotificationBoxComponent.prototype._checkNotifications = function () {
        this.notifications = this.notifications
            .map(function (notification) {
            notification.lifetime -= 1;
            return notification;
        })
            .filter(function (notification) { return notification.lifetime > 0; });
    };
    NotificationBoxComponent = __decorate([
        core_1.Component({
            selector: 'ejustice-notification-box',
            template: require('./notification-box.component.html'),
            styles: [require('./notification-box.component.css')],
            changeDetection: core_1.ChangeDetectionStrategy.OnPush
        }),
        __metadata("design:paramtypes", [idm_session_data_provider_api_js_1.EventBase,
            push_notification_service_1.PushNotificationService,
            core_1.ChangeDetectorRef,
            core_1.NgZone])
    ], NotificationBoxComponent);
    return NotificationBoxComponent;
}());
exports.NotificationBoxComponent = NotificationBoxComponent;
//# sourceMappingURL=notification-box.component.js.map